import React from "react";
import { Box, Paper, CircularProgress } from "@material-ui/core";

import ModalHeader from "../childrens/ModalHeader";
import ModalBody from "../childrens/ModalBody";

//css
import SectionCss from "./Section-css";
const useStyles = SectionCss();

export default function Section(props) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={"container"} style={{ maxWidth: 700 }}>
                <Box component="span" m={1}>
                    <Paper className={classes.root}>
                        {props.state.isLoading && (
                            <div align="center">
                                <CircularProgress />
                            </div>
                        )}
                        {!props.state.isLoading && (
                            <div className={classes.boxForm}>
                                <ModalHeader {...props} />
                                <ModalBody {...props} />
                            </div>
                        )}
                    </Paper>
                </Box>
            </div>
        </div>
    );
}
